import React, {useEffect} from "react";

import {Button, Flex, Space} from "antd";
import ComingSoon from "../../../../components/ComingSoon";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faAngleLeft} from "@fortawesome/free-solid-svg-icons";
import {useNavigate, useParams} from "react-router-dom";
import Title from "antd/es/typography/Title";
import {useAppSelector} from "../../../../feature/tools";
import {editorRoles, NavigateWithUserPermission} from "../../../common/WithUserPermission";


export const NotesContent = () => {
    const navigate = useNavigate()

    return (
        <NavigateWithUserPermission roles={editorRoles}>
            <Flex justify={'space-between'}>

                <Space>
                    <Button type={'text'}
                            onClick={() => navigate(-1)}
                            icon={<FontAwesomeIcon icon={faAngleLeft}/>}/>
                    <Title level={4} style={{margin: 0}}>Notes</Title>
                </Space>
            </Flex>

            <ComingSoon />
        </NavigateWithUserPermission>
    )
}